import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

import { IoTStateName } from './iot-state';

export interface IoT {
    name: string;
    type: IoTType;
    brand: IoTBrand;
    status: string | null;
    workflow_id: string | null;
    heartbeat_timestamp: string | null;
    version: string | null;
    update_timestamp: string;
    id: string;
    account_id: string;
    creation_timestamp: string;
    state: IoTStateName;
    twin_iot_id: string | null;

    display: string | null;
    domain: string | null;
    spot_id: string | null;
    default_user_interface_id: string | null;
}

export interface CreateIoT {
    name?: string;
    type?: IoTType;
    brand?: IoTBrand;
    status?: string | null;
    heartbeat_timestamp?: string | null;
    workflow_id?: string | null;
    state?: IoTStateName | null;
    twin_iot_id?: string | null;
}

export interface UpdateIoT {
    name?: string;
    type?: IoTType;
    brand?: IoTBrand;
    status?: string | null;
    heartbeat_timestamp?: string | null;
    workflow_id?: string | null;
    state?: IoTStateName | null;
    twin_iot_id?: string | null;
    display?: string | null;
    domain?: string | null;
    spot_id?: string | null;
    default_user_interface_id?: string | null;
}

export type IoTListResponse = PaginatedResponse<IoT>;

export enum IoTType {
    ACCESS_CONTROLLER = 'access_controller',
    ANDROID = 'android',
    MOBILE = 'mobile',
    PAYMENT_TERMINAL = 'payment_terminal',
    PRINTER = 'printer',
    SERVER = 'server',
}

export enum IoTBrand {
    ANDROID = 'android',
    ONLOGIC = 'onlogic',
    PRINT_NODE = 'print_node',
    RAKINDA = 'rakinda',
    TELLOPORT = 'telloport',
    VALINA = 'valina',
    ZHILAI = 'zhilai',
}

export enum QueryParams {
    ACCOUNT_ID = 'account_id',
    IDENTIFIER = 'identifier',
    TYPE = 'type',
    SPOT_ID = 'spot_id',
    WORKFLOW_ID = 'workflow_id'
}

export type IoTQueryParams = DefaultQueryParams | QueryParams;

export interface UpdateIoTState {
    state?: IoTStateName;
}
